import './StuList.scss';
import React, { useState, useEffect } from "react";
import fnc from '../../mymod/commFunction';
import { Checkbox } from '@mui/material';
import HongButton from '../../comm/HongButton';
import { normalizeAcaCode } from '../../mymod/normalizeAcaCode';


const StuList = ({selectedNodeItem, onStudentSelection, selectedStudents}) => {

    const [list, setList] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const acaCode = normalizeAcaCode(fnc.getCookie('certCode') || fnc.getCookie('acaCode'));

    // 선택된 학생들 가져오기
    const getSelectedStudents = () => {
        return list.filter(student => student.isChecked);
    };

    // 선택된 학생들이 변경될 때마다 부모에게 알림
    useEffect(() => {
        const selectedStudents = getSelectedStudents();
        onStudentSelection && onStudentSelection(selectedStudents);
    }, [list]);

    // 부모에서 selectedStudents가 변경되면 내부 체크박스 상태 동기화
    useEffect(() => {
        if (selectedStudents && list.length > 0) {
            const newList = list.map(student => {
                const isSelected = selectedStudents.some(selected => selected.id === student.id);
                return { ...student, isChecked: isSelected };
            });
            
            // 상태가 실제로 변경된 경우만 업데이트
            const hasChanged = newList.some((student, index) => student.isChecked !== list[index].isChecked);
            if (hasChanged) {
                setList(newList);
                
                // 모두 선택되었는지 확인
                const allChecked = newList.every(item => item.isChecked);
                setIsSelectAll(allChecked);
            }
        }
    }, [selectedStudents]);

    function onClickRow(item) {
    
    }

    useEffect(() => {
      if (selectedNodeItem) {
        const selectedClassCode = selectedNodeItem.node.key || '';
        fncSelect_list(selectedClassCode);
      }
    }, [selectedNodeItem]);



  function fncSelect_list(classCode) {


    fnc.sendAxios('/socialLoginRoutes/select/userInfoByClass', { classCode, acaCode }, (res) => {
      if (res && Array.isArray(res)) { 
        setIsSelectAll(false);
        setList(getRecords(res));
      } else {
        alert('데이터 조회 중 오류가 발생했습니다. 관리자에게 문의하세요.');
      }
    });
      
    function getRecords(res) {
      let records = [];
      res.forEach(item => {
          const id = item["id"];
          const stCode = item["stCode"];
          const name = item["name"];
          let hp = item["hp"];
          hp = fnc.formatPhoneNumber(hp);
          let hpParent = item["hp_parent"];
          hpParent = fnc.formatPhoneNumber(hpParent);
          const classCode = item["classCode"];
          const className = item["className"];
          const parentId = item["parentId"] || '';
          const parentName = item["parentName"] || `${name} 학부모`;
          const parentPhone = item["parentPhone"] || fnc.formatPhoneNumber(item["hp_parent"] || '');
          const parentRegisteredYn = item["parentRegisteredYn"] || 'N';
          const isChecked = false;//getRecords에서

          records.push({ id, stCode, name, hp, hpParent, classCode, className, parentId, parentName, parentPhone, parentRegisteredYn, isChecked });
      });
      return records;
  }

  }


  //---------------------------checkbox
  function handleCheckboxChange(event, index) {
    const isChecked = event.target.checked;
    const newList = [...list];
    newList[index].isChecked = isChecked;
    setList(newList);

  // 모두 체크되었는지 확인하여 헤더 체크박스 상태 업데이트
  const allChecked = newList.every(item => item.isChecked);
  setIsSelectAll(allChecked);
  }

  function handleSelectAllChange() {

    const newList = list.map(item => ({...item, isChecked: !isSelectAll }));
    setList(newList);
    setIsSelectAll(!isSelectAll);
  }//checkbox END

  // 이름 검색 함수
  function handleSearchByName() {
    if (!searchTerm.trim()) {
      alert('검색할 이름을 입력해주세요.');
      return;
    }

    const searchStr = `%${searchTerm.trim()}%`;
    fnc.sendAxios('/socialLoginRoutes/select/userInfoLikeName', { searchStr, acaCode }, (res) => {
      if (res && Array.isArray(res)) {
        setList(getRecordsForSearch(res));
        setIsSelectAll(false);
      } else {
        alert('검색 결과가 없습니다.');
        setList([]);
      }
    });
  }

  // 검색 결과용 레코드 변환
  function getRecordsForSearch(res) {
    let records = [];
    res.forEach(item => {
        const id = item["id"];
        const stCode = item["stCode"];
        const name = item["name"];
        let hp = item["hp"];
        hp = fnc.formatPhoneNumber(hp);
        let hpParent = item["hp_parent"];
        hpParent = fnc.formatPhoneNumber(hpParent);
        const classCode = '';
        const className = '검색결과';
        const parentId = item["parentId"] || '';
        const parentName = item["parentName"] || `${name} 학부모`;
        const parentPhone = item["parentPhone"] || fnc.formatPhoneNumber(item["hp_parent"] || '');
        const parentRegisteredYn = item["parentRegisteredYn"] || 'N';
        const isChecked = false;

        records.push({ id, stCode, name, hp, hpParent, classCode, className, parentId, parentName, parentPhone, parentRegisteredYn, isChecked });
    });
    return records;
  }

  // 검색 초기화
  function handleClearSearch() {
    setSearchTerm('');
    setList([]);
  }

  //=========================================
    return (

      <div className="StuList">
        <div className="wrap-main">
          <section className="section-main">
            <table className="table-hong table-main">
              <thead>
                <tr>
                  <th>No</th>
                  <th>
                    <Checkbox    
                        className="custom-checkbox"
                        checked={isSelectAll}
                        onChange={handleSelectAllChange} 
                    />
                  </th>
                  <th>성명</th>
                  <th>HP학생</th>
                  <th>HP학부모</th>
      
                </tr>
              </thead>

              <tbody>
                  {list && list.map((item, index) => (
  
                      <tr key={index} onClick={() => onClickRow(item)}>  
                        <td>{index+1}</td>

                        <td>
                            <Checkbox
                            className="custom-checkbox"
                            checked={item.isChecked}
                            onChange={(event) => handleCheckboxChange(event, index)} />
                        </td>

                        <td><p className='name'> {item.name}</p></td>
                
                        <td><span className='hp'> {item.hp}</span></td>
                        <td><span className='hpParent'> {item.hpParent}</span></td>
                      </tr>
                  ))}
            
                </tbody>
            </table>
          </section>

          {/* 이름 검색 섹션 */}
          <section className="section-search">
            <div className="search-container">
              <div className="search-input-group">
                <input
                  type="text"
                  placeholder="검색할 학생 이름을 입력하세요..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSearchByName()}
                  className="search-input"
                />
                <HongButton   
                  onClick={handleSearchByName}
                  className="search-button h-btn-red"
                >
                  검색
                </HongButton>
                <HongButton 
                  onClick={handleClearSearch}
                  className="clear-button h-btn-gray"
                >
                  초기화
                </HongButton>
              </div>
            </div>
          </section>

        </div>

      </div>

    );

};



      
    

export default StuList;



